import { useEffect } from 'react';

/**
 * Hook to set the page title dynamically
 * @param title - The title to set (will be appended with " - InsightStudio Labs")
 */
export const usePageTitle = (title: string) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title ? `${title} - InsightStudio Labs` : 'InsightStudio Labs - Research → Personas → Creative Testing';

    return () => {
      document.title = prevTitle;
    };
  }, [title]);
};
